export const GET_CATEGORIES = 'providers/menuMaker/MenuMakerCategories/GET_CATEGORIES';
export const GET_PAGINATION_CATEGORY = 'providers/menuMaker/MenuMakerCategories/GET_PAGINATION_CATEGORY';
export const CREATE_CATEGORY = 'providers/menuMaker/MenuMakerCategories/CREATE_CATEGORY';
export const DELETE_CATEGORY = 'providers/menuMaker/MenuMakerCategories/DELETE_CATEGORY';
export const DUPLICATE_CATEGORY = 'providers/menuMaker/MenuMakerCategories/DUPLICATE_CATEGORY';
